import { TouchEventHandler } from 'react'

export const createLongPressHandler = (
  onLongPress?: () => void,
  pressThreshold = 400
) => {
  let startTime: number
  let touchStartX: number
  let touchStartY: number
  let touchMoveHandler: (e: TouchEvent) => void
  let touchEndHandler: () => void
  let contextMenuHandler: (e: Event) => void
  let longPressTimeout: NodeJS.Timeout

  const handleTouchStart = (e: TouchEvent) => {
    // Prevent context menu immediately
    e.preventDefault()

    const touch = e.touches[0]
    startTime = Date.now()
    touchStartX = touch.clientX
    touchStartY = touch.clientY

    // Set up timeout to trigger long press
    longPressTimeout = setTimeout(() => {
      onLongPress?.()
    }, pressThreshold)

    touchMoveHandler = (e: TouchEvent) => {
      const touch = e.touches[0]
      const deltaX = Math.abs(touch.clientX - touchStartX)
      const deltaY = Math.abs(touch.clientY - touchStartY)

      // If user moved more than 10px, cancel the long press
      if (deltaX > 10 || deltaY > 10) {
        cleanup()
      }
    }

    touchEndHandler = () => {
      cleanup()
    }

    contextMenuHandler = (e: Event) => {
      e.preventDefault()
    }

    document.addEventListener('touchmove', touchMoveHandler, { passive: false })
    document.addEventListener('touchend', touchEndHandler)
    document.addEventListener('contextmenu', contextMenuHandler)
  }

  const cleanup = () => {
    clearTimeout(longPressTimeout)
    document.removeEventListener('touchmove', touchMoveHandler)
    document.removeEventListener('touchend', touchEndHandler)
    document.removeEventListener('contextmenu', contextMenuHandler)
  }

  return {
    onTouchStart: handleTouchStart as unknown as TouchEventHandler<HTMLElement>,
  }
}
